import React, { useContext, useEffect, useState } from 'react'
import {
  Box,
  TextField,
  MenuItem,
  Grid,
  Autocomplete,
  Chip,
} from '@mui/material'
import API from '../../services/API'
import { TenantSettingsContext } from '../../App'
import defaultEmployeeTeams from '../../helpers/auth/_defaultEmployeeTeams'

const VaultFilters = ({ vaultItems, setFilteredItems }) => {
  const [loadingOptions, setLoadingOptions] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')
  const [searchTags, setSearchTags] = useState([])
  // const [roleOptions, setRoleOptions] = useState([])
  const [searchRoles, setSearchRoles] = useState([])
  // const [teamOptions, setTeamOptions] = useState([])
  const [searchTeams, setSearchTeams] = useState([])

  const { orgConfig } = useContext(TenantSettingsContext)
  const roleOptions = orgConfig?.orgSettings?.roles ?? []
  const teamOptions = [
    ...defaultEmployeeTeams,
    ...(orgConfig?.orgSettings?.additionalTeams ?? []),
  ]

  // const handleSearch = (e) => {
  //   const term = e.target.value.toLowerCase()
  //   setSearchTerm(term)
  //   const filtered = vaultItems.filter((item) =>
  //     item.title.toLowerCase().includes(term)
  //   )
  //   setFilteredItems(filtered)
  // }

  useEffect(() => {
    if (
      searchTerm === '' &&
      searchTags.length === 0 &&
      searchRoles.length === 0 &&
      searchTeams.length === 0
    ) {
    }
    const filtered = vaultItems.filter((item) => {
      // Title includes search term (if typed)
      const matchesSearchTerm = searchTerm
        ? item.title.toLowerCase().includes(searchTerm.toLowerCase())
        : true

      // Tags match all selected (if any)
      const matchesTags =
        searchTags.length === 0 ||
        searchTags.every((tag) =>
          (item.tags || []).map((t) => String(t).trim()).includes(tag)
        )

      // Roles (if filter applied)
      const matchesRoles =
        searchRoles.length === 0 ||
        searchRoles.some((role) => (item.roles || []).includes(role))

      // Teams (if filter applied)
      const matchesTeams =
        searchTeams.length === 0 ||
        searchTeams.some((team) => (item.teams || []).includes(team))

      return matchesSearchTerm && matchesTags && matchesRoles && matchesTeams
    })

    setFilteredItems(filtered)
  }, [searchTerm, searchTags, searchRoles, searchTeams])

  const tagOptions = vaultItems.reduce((accumulator, vaultItem) => {
    vaultItem.tags.forEach((a) => {
      if (accumulator.some((x) => x === String(a).trim())) {
        return
      } else {
        accumulator.push(String(a).trim())
      }
    })
    return accumulator
  }, [])

  // useEffect(() => {
  //   API.get('/crewvaultsearchoptions')
  //     .then((res) => {
  //       if (res.status === 200) {
  //         // setRoleOptions(res.data.roles)
  //         setTeamOptions(res.data.teams)
  //       }
  //     })
  //     .catch((e) => console.error(e))
  //     .finally(() => setLoadingOptions(false))
  // }, [])

  return (
    <Box display="flex" gap={2} mt={2} flexWrap="wrap">
      <Grid container spacing={1}>
        <Grid item xs={12} md={6} lg={3}>
          <TextField
            label="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            fullWidth
            size="small"
            InputProps={{
              sx: {
                color: 'anGrey.main', // input text
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'anGrey.main', // border color
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'anGrey.main',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'anGrey.main',
                },
              },
            }}
            InputLabelProps={{
              sx: {
                color: 'anGrey.main', // label text
                '&.Mui-focused': {
                  color: 'anGrey.main',
                },
              },
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Autocomplete
            value={searchTags}
            onChange={(e, value) => setSearchTags(value ?? [])}
            options={tagOptions}
            multiple
            disableCloseOnSelect
            disableClearable
            size="small"
            renderTags={(value, getTagProps) =>
              value.map((option, index) => {
                const { key, ...tagProps } = getTagProps({ index }) // ✅ extract key properly

                return (
                  <Chip
                    key={key}
                    label={option}
                    {...tagProps}
                    variant="outlined"
                    color="anPurple"
                    size="small"
                    sx={{
                      borderRadius: 1,
                      height: 24,
                      fontSize: '0.75rem',
                      marginRight: 0.5,
                      backgroundColor: 'background.paper',
                    }}
                  />
                )
              })
            }
            renderInput={(params) => (
              <TextField {...params} label="Tags" size="small" />
            )}
            sx={{
              // '.MuiAutocomplete-inputRoot': {
              //   paddingTop: '4px !important',
              //   paddingBottom: '4px !important',
              // },
              '.MuiChip-root': {
                marginTop: '2px',
                marginBottom: '2px',
              },
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Autocomplete
            value={searchRoles}
            onChange={(e, value) => setSearchRoles(value ?? [])}
            options={roleOptions}
            multiple
            disableCloseOnSelect
            disableClearable
            size="small"
            renderTags={(value, getTagProps) =>
              value.map((option, index) => {
                const { key, ...tagProps } = getTagProps({ index })

                return (
                  <Chip
                    key={key}
                    label={option}
                    {...tagProps}
                    variant="outlined"
                    color="anGreen"
                    size="small"
                    sx={{
                      borderRadius: 1,
                      height: 24,
                      fontSize: '0.75rem',
                      marginRight: 0.5,
                      backgroundColor: 'background.paper',
                    }}
                  />
                )
              })
            }
            renderInput={(params) => (
              <TextField {...params} label="Roles" size="small" />
            )}
            sx={{
              '.MuiChip-root': {
                marginTop: '2px',
                marginBottom: '2px',
              },
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Autocomplete
            value={searchTeams}
            onChange={(e, value) => setSearchTeams(value ?? [])}
            options={teamOptions}
            multiple
            disableCloseOnSelect
            disableClearable
            size="small"
            renderTags={(value, getTagProps) =>
              value.map((option, index) => {
                const { key, ...tagProps } = getTagProps({ index })

                return (
                  <Chip
                    key={key}
                    label={option}
                    {...tagProps}
                    variant="outlined"
                    color="anBlue"
                    size="small"
                    sx={{
                      borderRadius: 1,
                      height: 24,
                      fontSize: '0.75rem',
                      marginRight: 0.5,
                      backgroundColor: 'background.paper',
                    }}
                  />
                )
              })
            }
            renderInput={(params) => (
              <TextField {...params} label="Teams" size="small" />
            )}
            sx={{
              '.MuiChip-root': {
                marginTop: '2px',
                marginBottom: '2px',
              },
            }}
          />
        </Grid>
      </Grid>

      {/* You can add more dropdowns for Assigned To, File Type, etc. */}
    </Box>
  )
}

export default VaultFilters
